import { changeOnboardingSubtask, getOnboardingStages } from '../api/api';
import { ONBOARDING_KIT_STEPS, ONBOARDING_KIT_SUBTASKS } from '../api/constants';
import { getOnboardingVariant } from '../api/onboardingVariant';

export const getKitLegalDocsSubtask = async () => {
    if (getOnboardingVariant() !== 'kit') {
        return undefined;
    }

    const data = await getOnboardingStages();
    const isPublished = data?.stages.find((s) => s.slug === ONBOARDING_KIT_STEPS.PUBLISH)?.is_completed;
    const stage = data?.stages.find((s) => s.slug === ONBOARDING_KIT_STEPS.COMPANY_INFO);
    const subtask = stage?.subtasks.find((task) => task.slug === ONBOARDING_KIT_SUBTASKS.LEGAL_DOCS_FILLED);

    return {
        isCompleted: subtask?.is_completed || isPublished,
        complete: () =>
            changeOnboardingSubtask({
                slug: ONBOARDING_KIT_SUBTASKS.LEGAL_DOCS_FILLED,
                value: true,
            }),
    };
};
